import * as Widget from '../widgets/base';
import * as Form from './form';

export function init_controls(config) {
  const controls = Widget.get(config).querySelector(`[data-controls]`)
  const back_button = controls.querySelector(`[data-step-back]`)
  const next_button = controls.querySelector(`[data-step-next]`)
  const submit_button = controls.querySelector(`[data-submit]`)

  back_button.addEventListener('click', function(e) {
    const current_step_index = config.steps.indexOf(active_step(config));

    show_step(config, config.steps[current_step_index - 1]);
  });

  next_button.addEventListener('click', function(e) {
    const current_step_index = config.steps.indexOf(active_step(config));

    validate_current_step(config);

    if (is_current_step_valid(config)) {
      show_step(config, config.steps[current_step_index + 1]);
    } else {
      console.log('invalid inputs')
    }
  });

  submit_button.addEventListener('click', function(e) {
    Form.submit(config);
  });
}

export function current_step_inputs(config) {
  const widget = Widget.get(config);
  const current_step = active_step(config);

  return current_step.fields
      .map((field) =>
        widget.querySelector(`#${field.key}-${config.widget.config.lead_form_id}`)
      ).filter(el => el !== null);
}

export function is_current_step_valid(config) {
  var inputs = current_step_inputs(config)

  return Array.from(inputs).every((input) => is_input_valid(input));
}

function is_input_valid(input) {
  switch (input.dataset.formFieldType) {
  case 'radiobuttons':
    const radio_options = input.querySelectorAll('input[type=radio]')

    const option_selected =
      [...radio_options]
        .map((radio_option) => radio_option.checkValidity())
        .every(Boolean)

    return option_selected;
    break;
  case 'multiselect':
    // not possible to support validation for this field
    // as it's been implemented with a hidden input

    return true;
    break;
  default:
    return input.checkValidity();
  }
}

function validate_input(input) {
  if (is_input_valid(input)) return;

  switch (input.dataset.formFieldType) {
  case 'radiobuttons':
    const radio_options = input.querySelectorAll('input[type=radio]')
    const first_option = radio_options[0];
    first_option.reportValidity();
    first_option.addEventListener("keydown", (_) => {
      first_option.setCustomValidity("");
    }, { once: true });

    break;

  case 'multiselect':
    // not possible to support validation for this field
    // as it's been implemented with a hidden input

    break;

  default:
    input.reportValidity();
    input.addEventListener("keydown", (_) => {
      input.setCustomValidity("");
    }, { once: true });
  }
}

export function validate_current_step(config) {
  // reversed so it starts showing validation errors from the top
  current_step_inputs(config).reverse().forEach((input) => {
    validate_input(input)
  });
}

export function active_step(config) {
  const step_elements = Widget.get(config).querySelectorAll(`[data-step]`)

  return config.steps.find((step) => {
    const step_container = Widget.get(config).querySelector(`[data-step='${step.id}']`)

    return !step_container.classList.contains('invisible')
  });
}

export function show_step(config, step) {
  config.steps.forEach((s) => {
    const step_container = Widget.get(config).querySelector(`[data-step='${s.id}']`)

    if (s.id == step.id) {
      step_container.classList.remove('invisible');
    } else {
      step_container.classList.add('invisible');
    }
  });

  const step_index = config.steps.indexOf(step);
  const n_steps = config.steps.length;
  const controls = Widget.get(config).querySelector(`[data-controls]`)
  const back_button = controls.querySelector(`[data-step-back]`)
  const next_button = controls.querySelector(`[data-step-next]`)
  const submit_button = controls.querySelector(`[data-submit]`)

  switch (true) {
    case step_index == 0:
      back_button.classList.add('invisible');
      next_button.classList.remove('invisible');
      submit_button.classList.add('invisible');
      break;

    case step_index == n_steps - 1:
      back_button.classList.remove('invisible');
      next_button.classList.add('invisible');
      submit_button.classList.remove('invisible');
      break;

    default:
      back_button.classList.remove('invisible');
      next_button.classList.remove('invisible');
      submit_button.classList.add('invisible');
      break;
  }
}